/* 🤖 this file was generated by svg-to-ts */
export const siriusCropDuotone: {
  name: 'crop_duotone';
  data: string;
} = {
  name: 'crop_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M6.75 2.25a.75.75 0 0 0-1.5 0v3h-3a.75.75 0 0 0 0 1.5h3V18c0 .414.336.75.75.75h11.25v3a.75.75 0 0 0 1.5 0v-3h3a.75.75 0 0 0 0-1.5h-15v-15Z" fill="currentColor"/><path d="M8.25 6A.75.75 0 0 1 9 5.25h9a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V6.75H9A.75.75 0 0 1 8.25 6Z" fill="currentColor"/></svg>`
};
